<template>
  <section class="deliveryListDiv">
    <viewTitle title="业务管理 / 车辆排队管理 / 成品出厂" :showReturn="false" />

    <!-- 按钮组1 -->
    <section class="controler">
      <div class="ctrLeft" style="width: 100%;">
        <el-radio-group
          v-model="params.state"
          @change="
            params.stop_state = stopStateArr[0].id;
            params.loading_state = loadingStateArr[0].id;
            radioChange;
          "
          size="small"
          fill="#3389f1"
          style="vertical-align: bottom;"
        >
          <el-radio-button label="1">排队中</el-radio-button>
          <el-radio-button label="2">已停止</el-radio-button>
          <el-radio-button label="3">装车中</el-radio-button>
        </el-radio-group>
        <span class="rectl">产品线：</span>
        <el-select
          class="ctl"
          clearable
          @clear="params.businessId = lineOption[0].id"
          v-model="params.businessId"
          placeholder="请选择产品线"
          @change="changeStatus"
        >
          <el-option
            :label="item.name"
            :value="item.id"
            v-for="(item, index) in lineOption"
            :key="index"
          ></el-option>
        </el-select>
        <template v-if="params.state == 2">
          <span class="rectl">状态：</span>
          <el-select
            class="ctl"
            clearable
            @clear="params.stop_state = stopStateArr[0].id"
            v-model="params.stop_state"
            @change="changeStatus"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in stopStateArr"
              :key="index"
            ></el-option>
          </el-select>
        </template>
        <template v-if="params.state == 3">
          <span class="rectl">状态：</span>
          <el-select
            class="ctl"
            clearable
            @clear="params.loading_state = loadingStateArr[0].id"
            v-model="params.loading_state"
            @change="changeStatus"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in loadingStateArr"
              :key="index"
            ></el-option>
          </el-select>
        </template>
        <el-input
          class="ctl rectl"
          style="width: 200px !important;"
          clearable
          placeholder="输入关键字搜索"
          suffix-icon="el-icon-search"
          v-model="params.keyword"
          @change="changeKeyword"
        ></el-input>
        <el-button
          class="rectl"
          type="primary"
          @click="refreshData"
          size="small"
          >刷新数据</el-button
        >
      </div>
    </section>
    <!-- 列表 -->
    <section class="main-table">
      <el-table
        v-if="showTable"
        :max-height="tableMaxSize"
        style="width: 100%;"
        show-overflow-tooltip
        :data="tableData"
        header-cell-class-name="table-header-cell"
        header-row-class-name="table-header-row"
        cell-class-name="table-cell"
        :border="true"
      >
        <el-table-column label="产品线">
          <template slot-scope="scope">
            <span>{{ scope.row.business_name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="排队编号">
          <template slot-scope="scope">{{ scope.row.code || "--" }}</template>
        </el-table-column>
        <el-table-column label="运输单位">
          <template slot-scope="scope">{{ scope.row.unit || "--" }}</template>
        </el-table-column>
        <el-table-column label="车牌号">
          <template slot-scope="scope">
            {{ scope.row.license_plate || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="车型">
          <template slot-scope="scope">
            <span v-if="scope.row.vehicle_type == 1">平板车</span>
            <span v-if="scope.row.vehicle_type == 2">货柜车</span>
            <span v-if="scope.row.vehicle_type == 3">槽罐车</span>
            <span v-if="scope.row.vehicle_type == 4">其他</span>
            <span v-if="scope.row.vehicle_type == 5">高栏车</span>
          </template>
        </el-table-column>
        <el-table-column label="手机号码">
          <template slot-scope="scope">
            {{ scope.row.contact || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="进厂时间">
          <template slot-scope="scope">
            <span>{{ intoTime(scope.row.into_factory_time) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <!-- 排队中  已停止 -->
            <span
              v-if="Number(params.state) === 1 || Number(params.state) === 2"
              :style="`color: ${queueColor[scope.row.queue_state]}`"
              >{{ queueState[scope.row.queue_state] }}</span
            >
            <!-- 装车中 -->
            <span
              v-if="Number(params.state) === 3"
              :style="`color: ${loadColor[scope.row.loading_state]}`"
              >{{ loadState[scope.row.loading_state] }}</span
            >
            <!-- <span v-if="scope.row.queue_state == 1">排队中</span>
            <span v-if="scope.row.queue_state == 2">叫号中</span>
            <span v-if="scope.row.queue_state == 3">已过号</span>
            <span v-if="scope.row.queue_state == 4">等待装货</span>
            <span v-if="scope.row.queue_state == 5">拒绝装货</span>
            <span v-if="scope.row.queue_state == 6">装货中</span>
            <span v-if="scope.row.queue_state == 7">装货完成</span>
            <span v-if="scope.row.queue_state == 8">已完成</span>
            <span v-if="scope.row.queue_state == 9">已终止</span>
            <span v-if="scope.row.queue_state == 10">
              已失效
            </span>-->
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="操作">
          <template slot-scope="scope">
            <div class="dropdown" @click.stop>
              <el-dropdown trigger="click" :hide-on-click="true">
                <span class="el-dropdown-link">
                  操作
                  <span class="el-icon-arrow-down"></span>
                </span>
                <el-dropdown-menu
                  slot="dropdown"
                  ref="dropdown"
                  v-if="
                    Number(scope.row.loading_state) == 0 &&
                      Number(scope.row.queue_state) == 1
                  "
                >
                  <!-- 排队中 -->
                  <el-dropdown-item @click.native.stop="viewDetail(scope.row)"
                    >查看详情</el-dropdown-item
                  >
                  <el-dropdown-item
                    @click.native.stop="moveUp('moveOne', scope)"
                    >上移一位</el-dropdown-item
                  >
                  <el-dropdown-item
                    @click.native.stop="moveUp('moveTop', scope)"
                    >置顶</el-dropdown-item
                  >
                  <el-dropdown-item
                    @click.native.stop="moveUp('moveBottom', scope)"
                    >移到最后</el-dropdown-item
                  >
                  <el-dropdown-item @click.native.stop="moveUp('stop', scope)"
                    >终止</el-dropdown-item
                  >
                </el-dropdown-menu>
                <el-dropdown-menu
                  slot="dropdown"
                  ref="dropdown"
                  v-if="
                    Number(scope.row.loading_state) == 0 &&
                      Number(scope.row.queue_state) == 6
                  "
                >
                  <!-- 已停止 查看详情-->
                  <el-dropdown-item @click.native.stop="viewDetail(scope.row)"
                    >查看详情</el-dropdown-item
                  >
                </el-dropdown-menu>
                <el-dropdown-menu
                  slot="dropdown"
                  ref="dropdown"
                  v-if="
                    Number(scope.row.loading_state) == 0 &&
                      Number(scope.row.queue_state) == 4
                  "
                >
                  <!-- 已失效 查看详情 重新排队-->
                  <el-dropdown-item @click.native.stop="viewDetail(scope.row)"
                    >查看详情</el-dropdown-item
                  >
                  <el-dropdown-item
                    @click.native.stop="moveUp('reQueue', scope)"
                    >重新排队</el-dropdown-item
                  >
                </el-dropdown-menu>
                <el-dropdown-menu
                  slot="dropdown"
                  ref="dropdown"
                  v-if="
                    Number(scope.row.loading_state) == 0 &&
                      Number(scope.row.queue_state) == 3
                  "
                >
                  <!-- 已过号 查看详情 重新排队 恢复排位-->
                  <el-dropdown-item @click.native.stop="viewDetail(scope.row)"
                    >查看详情</el-dropdown-item
                  >
                  <el-dropdown-item
                    @click.native.stop="moveUp('reQueue', scope)"
                    >重新排队</el-dropdown-item
                  >
                  <el-dropdown-item @click.native.stop="moveUp('reRank', scope)"
                    >恢复排位</el-dropdown-item
                  >
                </el-dropdown-menu>
                <el-dropdown-menu
                  slot="dropdown"
                  ref="dropdown"
                  v-if="
                    Number(scope.row.loading_state) !== 0 &&
                      (Number(scope.row.loading_state) == 5 ||
                        Number(scope.row.loading_state) == 6)
                  "
                >
                  <!-- 装车 已完成 已终止 -->
                  <el-dropdown-item @click.native.stop="viewDetail(scope.row)"
                    >查看详情</el-dropdown-item
                  >
                </el-dropdown-menu>
                <el-dropdown-menu
                  slot="dropdown"
                  ref="dropdown"
                  v-if="
                    Number(scope.row.loading_state) !== 0 &&
                      (Number(scope.row.loading_state) == 1 ||
                        Number(scope.row.loading_state) == 2 ||
                        Number(scope.row.loading_state) == 3 ||
                        Number(scope.row.loading_state) == 4)
                  "
                >
                  <!-- 装车 等待装货 拒绝装货 装货中 装货完成 -->
                  <el-dropdown-item @click.native.stop="viewDetail(scope.row)"
                    >查看详情</el-dropdown-item
                  >
                  <el-dropdown-item
                    @click.native.stop="moveUp('stopLoading', scope)"
                    >终止装车</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="page-wrap">
        <pagi
          :page="page"
          :pageSize="pageSize"
          :count="count"
          @pageChange="pageChange"
        ></pagi>
      </div>
    </section>

    <el-dialog :visible.sync="dialogParams.dialogMoveUpShow" width="30%">
      <template slot="title">
        <div style="font-size: 18px;">
          <i
            class="el-icon-success"
            style="color: #2acdcf;"
            v-if="dialogParams.title === '操作成功'"
          ></i>
          {{ dialogParams.title }}
        </div>
      </template>
      <div>
        <div v-html="dialogMoveUpContent"></div>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
        v-if="dialogParams.title === '确认提醒'"
      >
        <el-button @click="dialogParams.dialogMoveUpShow = false" size="small"
          >取 消</el-button
        >
        <el-button
          type="primary"
          @click="confirmMoveUp"
          v-loading.fullscreen.lock="fullscreenLoading"
          size="small"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </section>
</template>

<script>
import moment from "moment";
import pagi from "@/components/pagi/pagi";
import viewTitle from "@/components/viewTitle";
import mixinTableLyout from "@/views/rhqy/config/mixinTableLyout.js";
import keepAliveMinxin from "@/mixins/rh/keepAliveMinxin.js";
import { mapMutations, mapGetters } from "vuex";

export default {
  data() {
    return {
      // module_name: "services-advice",
      tabPosition: "left",
      pageSize: 50,
      count: 0, // 表格总数
      page: 1,
      params: {
        keyword: "", // 关键字搜索
        businessId: "", // 产品线
        state: "1",
        stop_state: 0,
        loading_state: 0
      },
      maxSize: 0,
      tableData: [], // 表格数据
      lineOption: [],
      dialogParams: {
        title: "确认提醒",
        dialogMoveUpShow: false, // 上移一位弹窗
        dialogType: "", // 弹窗类型，
        rowObj: null
      },
      fullscreenLoading: false,
      dialogMoveUpContent: "",
      calculationTimeInterval: null,
      queueState: [
        "",
        "排队中",
        "叫号中",
        "已过号",
        "已失效",
        "已完成",
        "已终止"
      ],
      queueColor: [
        "",
        "#008B5E",
        "#008B5E",
        "#EC3F67",
        "#666666",
        "#008B5E",
        "#EC3F67"
      ],
      loadState: [
        "",
        "装车中", // 等待装货
        "装车中", // 拒绝装货
        "装车中", // 装货中
        "装车中", // 装货完成
        "已完成",
        "已终止"
      ],
      loadColor: [
        "",
        "#008B5E",
        "#008B5E",
        "#008B5E",
        "#008B5E",
        "#008B5E",
        "#EC3F67"
      ],
      toKeepAlivePath: "/rhqy/service/queue/DeliveryList/detail", // 当前路由访问某个页面时的不清除缓存
      stopStateArr: [
        { id: 0, name: "全部" },
        { id: 3, name: "已过号" },
        { id: 4, name: "已失效" },
        { id: 6, name: "已终止" }
      ],
      loadingStateArr: [
        { id: 0, name: "全部" },
        { id: 1, name: "装车中" },
        { id: 2, name: "已完成" },
        { id: 3, name: "已终止" }
      ]
    };
  },

  beforeRouteLeave(_to, _form, next) {
    window.clearInterval(this.calculationTimeInterval);
    this.calculationTimeInterval = 0;
    next();
  },

  mixins: [mixinTableLyout, keepAliveMinxin],

  components: {
    pagi,
    viewTitle
  },

  computed: {
    ...mapGetters(["queueList", "socketDebugA"]),
    lineName() {
      let rename = "";
      this.lineOption.forEach(element => {
        if (element.id == this.params.businessId) {
          rename = element.name;
        }
      });
      return rename;
    },

    intoTime() {
      return str => {
        // return moment(time).format("YYYY-MM-DD");
        let colYear = Number(moment(Number(str) * 1000).format("YYYY"));
        if (moment().year() === colYear) {
          return moment(Number(str) * 1000).format("MM月DD日 HH:mm");
        } else {
          return moment(Number(str) * 1000).format("YYYY年MM月DD日 HH:mm");
        }
      };
    }
  },

  watch: {
    params: {
      handler() {
        this.page = 1;
        this.getList();
      },
      deep: true
    }
  },

  async mounted() {
    // let LineOption = await this.getLineOption();
    // LineOption.data.data.forEach(item => {
    //   this.lineOption.push(item);
    // });
    // this.params.businessId = this.lineOption[0].id;
  },

  async activated() {
    let LineOption = await this.getLineOption();
    this.lineOption = [];
    LineOption.data.data.forEach(item => {
      this.lineOption.push(item);
    });
    if (this.params.businessId.length == 0) {
      this.params.businessId = this.lineOption[0].id;
    } else {
      this.getList();
    }

    this.calculationTimeInterval = 0;
    this.calculationTimeInterval = window.setInterval(() => {
      this.getList();
    }, 20000);
  },

  created() {
    // this.getList();
    // this.calculationTimeInterval = window.setInterval(() => {
    //   this.getList();
    // }, 20000);
    // this.inRoom();
  },

  methods: {
    ...mapMutations(["sendSocket", "inRoom"]),
    // 切换页码
    pageChange(page) {
      this.page = page;
      this.getList();
    },

    changeStatus() {
      // this.getList();
    },

    // 关键字搜索
    changeKeyword(val) {
      // this.page = 1;
      this.params.keyword = val;
      // this.getList();
    },

    // 获取列表
    async getList() {
      let dataObj = await this.$common.http({
        url: "/api/queue/admin/query_queue",
        data: {
          business_id: this.params.businessId,
          keyword: this.params.keyword,
          state: this.params.state,
          page: this.page,
          page_size: this.pageSize,
          stop_state: this.params.stop_state,
          loading_state: this.params.loading_state
        }
      });
      // dataObj = {
      //   errcode: 0,
      //   errmsg: "成功",
      //   data: {
      //     current_page: 1,
      //     data: [
      //       {
      //         id: "4",
      //         queue_state: 1,
      //         valid_state: 1,
      //         ranking: 1,
      //         unit: "",
      //         license_plate_type: 1,
      //         license_plate: "粤954485",
      //         contact: "18814142694",
      //         into_factory_time: 1604910216,
      //         booking_info_id: "3be07279fe9d46e3a15319a8511df9a7"
      //       },
      //       {
      //         id: "3",
      //         queue_state: 1,
      //         valid_state: 1,
      //         ranking: 2,
      //         unit: "",
      //         license_plate_type: 1,
      //         license_plate: "粤954485",
      //         contact: "18814142694",
      //         into_factory_time: 1604910216,
      //         booking_info_id: "3be07279fe9d46e3a15319a8511df9a7"
      //       },
      //       {
      //         id: "1",
      //         queue_state: 1,
      //         valid_state: 1,
      //         ranking: 3,
      //         unit: "",
      //         license_plate_type: 1,
      //         license_plate: "粤954485",
      //         contact: "18814142694",
      //         into_factory_time: 1604910216,
      //         booking_info_id: "3be07279fe9d46e3a15319a8511df9a7"
      //       },
      //       {
      //         id: "2",
      //         queue_state: 1,
      //         valid_state: 1,
      //         ranking: 4,
      //         unit: "",
      //         license_plate_type: 1,
      //         license_plate: "粤954485",
      //         contact: "18814142694",
      //         into_factory_time: 1604910216,
      //         booking_info_id: "3be07279fe9d46e3a15319a8511df9a7"
      //       },
      //       {
      //         id: "5",
      //         queue_state: 1,
      //         valid_state: 1,
      //         ranking: 8,
      //         unit: "",
      //         license_plate_type: 1,
      //         license_plate: "粤954485",
      //         contact: "18814142694",
      //         into_factory_time: 1604910216,
      //         booking_info_id: "3be07279fe9d46e3a15319a8511df9a7"
      //       }
      //     ],
      //     first_page_url: "/?page=1",
      //     from: 1,
      //     last_page: 1,
      //     last_page_url: "/?page=1",
      //     next_page_url: null,
      //     path: "/",
      //     per_page: 15,
      //     prev_page_url: null,
      //     to: 5,
      //     total: 5
      //   }
      // };
      this.tableData = dataObj.data.data.data;
      this.count = dataObj.data.data.total;
    },

    // 修改产品线
    changeLine(val) {
      // this.page = 1;
      console.log(val);
      // this.getList();
    },

    // 刷新数据
    refreshData() {
      // this.page = 1;
      this.getList();
    },

    // 点击radio(切换状态)
    radioChange(val) {
      console.log(val);
      // this.page = 1;
      this.params.state = val;
    },

    // 查看详情
    viewDetail(row) {
      console.log(row);
      this.$router.push({
        path: "/rhqy/service/queue/DeliveryList/detail",
        query: {
          booking_info_id: row.booking_info_id,
          id: row.id
        }
      });
    },

    // 上移一位
    moveUp(tag, data) {
      console.log(tag, data);
      this.dialogParams.dialogType = tag;
      this.dialogParams.rowObj = data;
      let licensePlate = data.row.license_plate;
      // let index = data.$index + 1 + (this.page - 1) * this.pageSize;
      let queue_id = this.dialogParams.rowObj.row.id;
      this.$common
        .http({
          url: "/api/queue/admin/get_queue_ranking",
          // method: "GET",
          data: {
            queue_id
          }
        })
        .then(res => {
          console.log(res.data.data);
          let index = res.data.data;
          if (tag === "moveOne") {
            this.dialogMoveUpContent = `“<span class="color67">${licensePlate}</span>”当前处于<span class="color67">第${index}位</span>，确定要<span class="color67">上移一位</span>吗？`;
          } else if (tag === "moveTop") {
            this.dialogMoveUpContent = `“<span class="color67">${licensePlate}</span>”当前处于<span class="color67">第${index}位</span>，确定要<span class="color67">置顶到第1位</span>吗？`;
          } else if (tag === "moveBottom") {
            this.dialogMoveUpContent = `“<span class="color67">${licensePlate}</span>”当前处于<span class="color67">第${index}位</span>，确定要<span class="color67">移到最后</span>吗？`;
          } else if (tag === "stop") {
            this.dialogMoveUpContent = `确定要终止“<span class="color67">${licensePlate}</span>”的排队吗？这将从排队队列中移除该车辆，车辆将无法被叫号！`;
          } else if (tag === "reQueue") {
            this.dialogMoveUpContent = `确定要对“<span class="color67">${licensePlate}</span>”重新排队吗？这意味着车辆要从最后一位重新开始排队！`;
          } else if (tag === "reRank") {
            this.dialogMoveUpContent = `确定要对“<span class="color67">${licensePlate}</span>”恢复排位吗？这意味着车辆将立即加入排队并处于<span class="color67">第1位</span>！`;
          } else if (tag === "stopLoading") {
            this.dialogMoveUpContent = `确定要终止“<span class="color67">${licensePlate}</span>”的装车吗？`;
          }
          this.dialogParams.dialogMoveUpShow = true;
          this.dialogParams.title = "确认提醒";
        });
    },

    // 确认操作
    confirmMoveUp() {
      this.dialogParams.dialogMoveUpShow = false;
      if (this.dialogParams.title === "确认提醒") {
        let tag = this.dialogParams.dialogType;
        let queue_id = this.dialogParams.rowObj.row.id;
        let licensePlate = this.dialogParams.rowObj.row.license_plate;
        // let index =
        //   this.dialogParams.rowObj.$index +
        //   (this.page - 1) * this.pageSize;

        if (tag === "moveOne") {
          this.$common
            .http({
              url: "/api/queue/admin/move_up_queue",
              data: {
                queue_id
              }
            })
            .then(() => {
              this.$common
                .http({
                  url: "/api/queue/admin/get_queue_ranking",
                  // method: "GET",
                  data: {
                    queue_id
                  }
                })
                .then(res => {
                  console.log(res.data.data);
                  let index = res.data.data;
                  this.getList();
                  // this.dialogMoveUpContent = `“<span class="color67">${licensePlate}</span>”已成功上移一位，当前处于<span class="color67">第${index}位</span>`;
                  // this.dialogParams.title = "操作成功";
                  // this.dialogParams.dialogMoveUpShow = true;
                  this.$common.pcToastSuccess(
                    `“${licensePlate}”已成功上移一位，当前处于第${index}位`
                  );
                });
            });
        } else if (tag === "moveTop") {
          this.$common
            .http({
              url: "/api/queue/admin/set_top_queue",
              data: {
                queue_id
              }
            })
            .then(() => {
              this.getList();
              // this.dialogMoveUpContent = `“<span class="color67">${licensePlate}</span>”已成功置顶，当前处于<span class="color67">第1位</span>;`;
              // this.dialogParams.title = "操作成功";
              // this.dialogParams.dialogMoveUpShow = true;
              this.$common.pcToastSuccess(
                `“${licensePlate}”已成功置顶，当前处于第1位;`
              );
            });
        } else if (tag === "moveBottom") {
          this.$common
            .http({
              url: "/api/queue/admin/set_bottom_queue",
              data: {
                queue_id
              }
            })
            .then(() => {
              this.getList();
              // this.dialogMoveUpContent = `“<span class="color67">${licensePlate}</span>”已成功置顶，当前处于<span class="color67">第1位</span>;`;
              // this.dialogParams.title = "操作成功";
              // this.dialogParams.dialogMoveUpShow = true;
              this.$common.pcToastSuccess(
                `“${licensePlate}”已成功置低，当前处于最后一位;`
              );
            });
        } else if (tag === "stop") {
          this.$common
            .http({
              url: "/api/queue/admin/remove_queue",
              data: {
                queue_id
              }
            })
            .then(() => {
              this.getList();
              // this.dialogMoveUpContent = `已成功从排队队列中移除“<span class="color67">${licensePlate}</span>”`;
              // this.dialogParams.title = "操作成功";
              // this.dialogParams.dialogMoveUpShow = true;
              this.$common.pcToastSuccess(
                `已成功从排队队列中移除“${licensePlate}”`
              );
            });
        } else if (tag === "reQueue") {
          this.$common
            .http({
              url: "/api/queue/admin/afresh_rank",
              data: {
                queue_id
              }
            })
            .then(() => {
              this.getList();
              // this.dialogMoveUpContent = `“<span class="color67">${licensePlate}</span>”已成功重新排队`;
              // this.dialogParams.title = "操作成功";
              // this.dialogParams.dialogMoveUpShow = true;
              this.$common.pcToastSuccess(`${licensePlate}”已成功重新排队`);
            });
        } else if (tag === "reRank") {
          this.$common
            .http({
              url: "/api/queue/admin/restore_rank",
              data: {
                queue_id
              }
            })
            .then(() => {
              this.getList();
              // this.dialogMoveUpContent = `“<span class="color67">${licensePlate}</span>”已成功恢复排位，当前处于<span class="color67">第1位</span>`;
              // this.dialogParams.title = "操作成功";
              // this.dialogParams.dialogMoveUpShow = true;
              this.$common.pcToastSuccess(
                `“${licensePlate}”已成功恢复排位，当前处于第1位`
              );
            });
        } else if (tag === "stopLoading") {
          this.$common
            .http({
              url: "/api/queue/admin/stop_loading_queue",
              data: {
                queue_id
              }
            })
            .then(() => {
              this.getList();
              this.$common.pcToastSuccess(`“${licensePlate}”已终止装车`);
            });
        }
        // this.dialogParams.dialogMoveUpShow = false;
        // this.fullscreenLoading = true;
        // setTimeout(() => {
        //   if (this.dialogParams.dialogType === "moveOne") {
        //     this.dialogMoveUpContent =
        //       '“<span class="color67">粤C80394</span>”已成功上移一位，当前处于<span class="color67">第4位</span>';
        //   } else if (this.dialogParams.dialogType === "moveTop") {
        //     this.dialogMoveUpContent =
        //       '“<span class="color67">粤C80394</span>”已成功置顶，当前处于<span class="color67">第1位</span>';
        //   } else if (this.dialogParams.dialogType === "stop") {
        //     this.dialogMoveUpContent =
        //       '已成功从排队队列中移除“<span class="color67">粤C80394</span>”';
        //   } else if (this.dialogParams.dialogType === "reQueue") {
        //     this.dialogMoveUpContent =
        //       '“<span class="color67">粤C80394</span>”已成功重新排队，当前处于“<span class="color67">第10位</span>”';
        //   } else if (this.dialogParams.dialogType === "reRank") {
        //     this.dialogMoveUpContent =
        //       '“<span class="color67">粤C80394</span>”已成功恢复排位，当前处于<span class="color67">第1位</span>';
        //   }
        //   this.dialogParams.title = "操作成功";
        //   this.fullscreenLoading = false;
        //   this.dialogParams.dialogMoveUpShow = true;
        // }, 1000);
        // // 自动关闭弹窗
        // setTimeout(() => {
        //   this.dialogParams.dialogMoveUpShow = false;
        // }, 3000);
      }
    },
    getLineOption() {
      return this.$common.http({
        method: "get",
        url: "/api/queue/admin/query_queue_business"
      });
    }
  }
};
</script>

<style scoped lang="less">
@import "../assets/css/common";
.deliveryListDiv {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 16px 16px 0 16px;
  overflow: auto;
  & > .header {
    margin: 0px 0 24px 0;
    font-size: 20px;
    line-height: 20px;
    color: #4a4a4a;
  }
  & > .controler {
    display: flex;
    margin-bottom: 16px;
    .ctl {
      display: inline-block;
      width: 150px !important;
    }
    .rectl {
      margin-left: 15px;
    }
    .ctl.mid {
      width: 16% !important;
    }
    .ctl.lar {
      width: 22% !important;
    }
    .ctrRight {
      float: right;
      margin: 0;
    }
    .ctl_fix {
      margin-top: -1px;
      margin-bottom: 0;
      line-height: 18px;
      vertical-align: middle;
      padding: 0 8px 0 10px;
      .el-range__close-icon {
        position: absolute;
        top: 0px;
        right: 2px;
      }
    }
  }
  & > .main-table {
    width: 100%;
  }
  .page-wrap {
    padding-top: 10px;
  }
}
</style>
<style lang="less">
.deliveryListDiv {
  .el-radio-button--small .el-radio-button__inner {
    font-size: 14px;
  }
}
</style>
